<template>
  <li class="list-item user-count">
    <x-angleIcon></x-angleIcon>
    <h3><i class="iconfont iconicon_jiantou"></i>住户总数趋势</h3>
    <div id="userCount"></div>
  </li>
</template>

<script>
import chartOpt from '@/utils/chartOptions';
export default {
  name: 'userCount',
  data () {
    return {
      cId: '',
      userCount: {}
    };
  },
  created () {
    this.getDataViewQuery(this);
  },
  mounted () {
    this.userCountChart();
  },
  methods: {
    /* 获取用户总数 */
    getUserCount () {
      return new Promise((resolve, reject) => {
        this.$get({
          url: '/zw_statistics/user_statistics',
          params: {community_id: this.cId},
          config: { timeout: 20000 }
        }).then(({data}) => {
          let date = [];
          let value = [];
          data && data.forEach((ele) => {
            date.push(`${ele.month}月`);
            value.push(ele.value);
          });
          this.userCount.xAxis[0].setCategories(date);
          this.userCount.series[0].setData(value);
        });
      });
    },
    /* 每个月用户的总数走势图 */
    async userCountChart () {
      this.userCount = this.Highcharts.chart('userCount', chartOpt.lineOptions);
      this.getUserCount();
    }
  }
};
</script>
<style lang="scss">
  #userCount {
    height: 100%;
  }
</style>
